/**
 * enable new r2b nudge emails and in-app nudges
 * Product Area: R2B_REFERRALS
 */
export const ENABLE_REFERRAL_ADOPTION_231004 = 'ENABLE_REFERRAL_ADOPTION_231004';
